import { colors } from 'ui/theme/colors';
import { getColor } from '../utils';
import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const Edit24 = ({
  height = 24,
  width = 24,
  color = colors.grey90,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon height={height} width={width} viewBox="0 0 24 24" {...props}>
    <path
      d="M19.2 8.8L9.06667 18.9333L4 20L5.06667 14.9333L15.2 4.8C16.2667 3.73333 18.1333 3.73333 19.2 4.8C20.2667 6 20.2667 7.73333 19.2 8.8Z"
      stroke={getColor(color, isColorInherited)}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
